// extracted by mini-css-extract-plugin
module.exports = {"menu":"_1TnVd45vvrSp2-LU47ba-I","menu900":"_3C5BiAXZoaRRsyIwaFNPYa"};